import React from "react";
import "./style.css";
const PageNotFound = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="page_not_found">
            <h1>Page Not Found</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
